// pages/Dashboard.jsx
import ContactUs from "../../components/home/authComponents/ContactUs";
import HomeLayout from "../../components/home/HomeLayout";

export default function Dashboard() {
  return (
    <HomeLayout>
      <ContactUs />
    </HomeLayout>
  );
}
